import { useState } from "react";
import { Button, Modal } from "react-bootstrap";

interface NavigationBlockerModalProps {
  onProceed: () => void;
  onCancel: () => void;
}

function NavigationBlockerModal({
  onProceed,
  onCancel,
}: NavigationBlockerModalProps) {
  const [show, setShow] = useState(true);

  const handleClose = () => {
    setShow(false);
    onCancel();
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Are you sure you want to leave?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Unsaved changes will be lost upon leaving this page.
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onProceed}>
          Proceed
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default NavigationBlockerModal;
